var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NotificationsRoot",
    {
      attrs: {
        authorized: _vm.userIsAuthorized,
        authorizedRole: "registeredUser",
      },
      scopedSlots: _vm._u([
        {
          key: "sub-nav",
          fn: function () {
            return [_c("DeviceTopNav")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "transition",
        { attrs: { name: "delay-entry" } },
        [
          _vm.showModal && _vm.authenticateWithPin
            ? _c("PinAuthenticationModal", {
                on: { submit: _vm.submit, cancel: _vm.closePinModal },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "delay-entry" } },
        [
          _vm.welcomeModalVisible
            ? _c("PostSetupModalGroup", {
                on: { cancel: _vm.hideWelcomeModal },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }